import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Config from "./Config";
import Cookies from "js-cookie";
import Sidebar from "./Sidebar";
import { Link, useNavigate } from "react-router-dom";
import Profuserpie from "./Chart/Profuserpie";
import Profusergraph from "./Chart/Profusergraph";
import { MdHomeRepairService } from "react-icons/md";
import { FaThumbsUp, FaUserTie, FaUsers } from "react-icons/fa";
import { SiGooglemessages } from "react-icons/si";
import { IoIosNotificationsOutline } from "react-icons/io";
import Projectgraph from "./Chart/Projectgraph";
import Blogpie from "./Chart/Blogpie";
import Enquirypie from "./Chart/Enquirypie";
import { useAuthHandling } from './useAuthhandling';

function Dashboard() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }

  const [customerdata, setCustomer] = useState([]);
  const [profcount, setProf] = useState([]);
  const [customercount, setCustcount] = useState([]);
  const [servicecount, setServicecount] = useState([]);
  const [notification, setNotification] = useState([]);
  const [subscriberdata, setSubscriber] = useState([]);
  const[dashboarddata,setDashboarddata]=useState([]);

  

  const getDashboard = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/dashboard/get-dashboard`, {
      method: "GET",
      headers: { "Content-Type": "application/json" ,
      Authorization: `Bearer ${Cookies.get("a_token")}`,

    },
    });
    if (res.status === 200) {
      const data = await res.json();
      setDashboarddata(data.data[0]);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getDashboard();
    }
    else {
      alert("error");

    }
  };

  useEffect(() => {
   
    getDashboard();
  }, []);

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/user/search-normal-users-only?searchTerm=&page=1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();
      setCustomer(data.data[0].totalCount);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  return (
    <div>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          {/* partial:partials/_settings-panel.html */}
          <Sidebar />

          {/* partial */}
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 grid-margin">
                  <div className="row">
                    <div className="col-12 col-xl-5 mb-4 mb-xl-0">
                      {/* <h4 className="font-weight-bold">Hi, Welcomeback!</h4> */}
                      <h4 className="font-weight-normal mb-0">Dashboard</h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
              <div className="row">
                <div className="col-xl-8 dashboard-col">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-sm-6 dashbord-service-card">
                          <div className="card card1">
                            <div className="card-body">
                              <div className="card-body-service">
                                {/* <MdHomeRepairService /> */}
                                <FaUserTie />
                                <h5>Total Professionals</h5>
                              </div>
                            </div>
                            <div className="card_verifications ">
                            <div className="card-footer col-md-6 border_12">
                            
                              <h6 className="card-footer-service ">
                                {dashboarddata.professionalUsersVerified} Verified
                              </h6>
                             
                            </div>
                            <div className="card-footer col-md-6">
                            <Link to="/unverifiedprofessional" className="dash_unver">
                            <h6 className="card-footer-service">
                               {dashboarddata.professionalUsersNotVerified} Unverified
                            </h6>
                            </Link>
                            </div>
                          </div>
                          </div>
                        </div>
                        <div className="col-sm-6 dashbord-service-card1">
                          <div className="card card2">
                            <div className="card-body">
                              <div className="card-body-service">
                                {/* <MdHomeRepairService /> */}
                                <FaUsers />
                                <h5>Total Users</h5>
                              </div>
                            </div>
                            <div className="card_verifications ">
                            <div className="card-footer col-md-6 border_12">
                            
                              <h6 className="card-footer-service ">
                              {dashboarddata.totalNormalUsers} (total)
                              </h6>
                             
                            </div>
                            <div className="card-footer col-md-6">
                            <Link to="/unverifiedprofessional" className="dash_unver">
                            <h6 className="card-footer-service">
                               {customerdata.total_rows} (normal)
                            </h6>
                            </Link>
                            </div>
                          </div>
                          </div>
                        </div>
                        {/* <div className="col-sm-6 dashbord-service-card1">
                          <div className="card card2">
                            <div className="card-body">
                              <div className="card-body-subscribe">
                               
                                <FaUsers />
                                <h5>Total Users</h5>
                              </div>
                            </div>
                            <div className="card-footer border_14">
                              <h5 className="card-footer-subscribe">
                                {dashboarddata.totalNormalUsers} Numbers
                              </h5>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className="col-md-4 dashboard-msg">
                      <div className="col-12 col-md-12 col-sm-6 dashboard-msg1">
                        <div className="card card3">
                          <div className="card-body card-body-3">
                            <SiGooglemessages className="card-body-3-message-sign" />
                            <h5 className="card-body-3-message">Enquiry</h5>
                            <h5 className="card-body-3-message-count">{dashboarddata.enquiryCount}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-sm-6 mt-2 dashboard-msg2">
                        <div className="card card3">
                          <div className="card-body card-body-3">
                            <IoIosNotificationsOutline className="card-body-3-note-sign" />
                            <h5 className="card-body-3-note">Converted Project</h5>
                            <h5 className="card-body-3-note-count">{dashboarddata.projectsCount}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-6">
                      <Profuserpie dashboarddata={dashboarddata}/>
                    </div>
                    <div className="col-md-6">
                    <Enquirypie dashboarddata={dashboarddata}/>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <Projectgraph />
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 dashboard-col1">
                  <div className="col-12">
                  <Blogpie />
                
                  </div>
                  <div className="col-12 mt-5">
                    <Profusergraph />
                  </div>
                </div>
              </div>

              {/* \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ */}
            </div>
            {/* content-wrapper ends */}
            {/* partial:partials/_footer.html */}

            {/* partial */}
          </div>

          {/* main-panel ends */}
        </div>
        {/* page-body-wrapper ends */}
      </div>
    </div>
  );
}

export default Dashboard;
